import {
  EnvironmentProviders,
  ErrorHandler,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';
import { Router } from '@angular/router';
import * as SentryBrowser from '@sentry/angular';

/**
 * Sentry для браузера: глобальный ErrorHandler (без диалога), TraceService
 * для трейсинга роутинга и его инициализация через app-initializer.
 */
export function provideSentryBrowser(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: ErrorHandler,
      useValue: SentryBrowser.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: SentryBrowser.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      inject(SentryBrowser.TraceService);
    }),
  ]);
}
